import { useEffect, useId, useState } from 'react';
import { createPortal } from 'react-dom';
import {
  EVIDENCE_TYPES,
  EVIDENCE_TYPES_FOOTNOTE,
  EVIDENCE_TYPES_INTRO,
} from '../lib/disputeTypes.js';

export default function EvidenceTypesHelp() {
  const [open, setOpen] = useState(false);
  const titleId = useId();

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKeyDown);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = prev;
    };
  }, [open]);

  const modal =
    open && typeof document !== 'undefined'
      ? createPortal(
          <div
            className="social-modal-backdrop evidence-types-backdrop"
            role="presentation"
            onClick={() => setOpen(false)}
          >
            <div
              className="social-modal evidence-types-modal"
              role="dialog"
              aria-modal="true"
              aria-labelledby={titleId}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="social-modal-head">
                <h2 id={titleId}>Types of evidence we accept</h2>
                <button
                  type="button"
                  className="social-modal-close"
                  onClick={() => setOpen(false)}
                  aria-label="Close"
                >
                  ×
                </button>
              </div>
              <div className="evidence-types-body">
                <p className="social-modal-hint">{EVIDENCE_TYPES_INTRO}</p>
                <ul className="evidence-types-list">
                  {EVIDENCE_TYPES.map((item) => (
                    <li key={item.title}>
                      <strong>{item.title}</strong>
                      <span>{item.detail}</span>
                    </li>
                  ))}
                </ul>
                <p className="evidence-types-footnote">{EVIDENCE_TYPES_FOOTNOTE}</p>
              </div>
              <div className="evidence-types-actions">
                <button type="button" className="btn-primary" onClick={() => setOpen(false)}>
                  Got it
                </button>
              </div>
            </div>
          </div>,
          document.body
        )
      : null;

  return (
    <>
      <button
        type="button"
        className="text-link evidence-types-link"
        onClick={() => setOpen(true)}
      >
        Types of evidence we accept
      </button>
      {modal}
    </>
  );
}
